module.exports = __webpack_public_path__ + "static/media/mk8-hilux-small.41472b70.jpg";